import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { baseurImage } from "../../../Baseurl";

export default function ViewUser() {
  const location = useLocation();
  const navigate = useNavigate();
  const user = location.state?.user;

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB");
  };

    // Helper function to get staff image URL
    const getUserImageUrl = (user) => {
      if (user.personalPhoto && user.personalPhoto !== "null" && user.personalPhoto !== "undefined") {
        return `${baseurImage}${user.personalPhoto}`;
      }
      // Return default avatar if no personal photo
      return "../assets/images/user/avatar-2.jpg";
    };
  



  if (!user) {
    return (
      <div className="pc-container">
        <div className="pc-content">
          <div className="col-12">
            <div className="card table-card">
              <div className="tableHeader">
                <h5 style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <span
                    style={{ cursor: 'pointer', fontWeight: 'bold', fontSize: '1.5rem' }}
                    onClick={() => navigate(-1)}
                    title="Back"
                  >
                    &larr;
                  </span>
                  User Details
                </h5>
              </div>
              <div className="card-body text-center">
                <p>No user data available</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="pc-container">
      <div className="pc-content">
        <div className="col-12">
          <div className="card table-card">
            <div className="tableHeader">
              <h5 style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <span
                  style={{ cursor: 'pointer', fontWeight: 'bold', fontSize: '1.5rem' }}
                  onClick={() => navigate(-1)}
                  title="Back"
                >
                  &larr;
                </span>
                User Details
              </h5>
            </div>
            <div className="card-body" style={{ margin: "15px" }}>
              <div className="row justify-content-center mb-4">
                
                  <div className="col-lg-12">
                    <div className="drImg">
                    
                  <img
                          src={getUserImageUrl(user)}
                    alt={user.fullName}
                   
                     onError={(e) => { e.currentTarget.src = "../assets/images/user/avatar-2.jpg"; }}
                  />
                  </div>
                  
                </div>
              </div>

              <div className="row">
                {[
                  ["Prefix", user.prefix || "N/A"],
                  ["First Name", user.fullName],
                   ["Last Name", user.shortName || "N/A"],
                  ["Email", user.email],
                  ["Phone Number", user.phoneNumber],
                  ["Civil ID", user.civilId],
                  ["Date of Birth", formatDate(user.dateOfBirth)],
                  ["Gender", user.gender],
                  ["Role", user.role],
                  ["License ID", user.licenseId || "N/A"],
                  ["Passport", user.passport || "N/A"],
                  ["Specialty", user.specialty || "N/A"],

                  // ["Short Name", user.shortName || "N/A"],
                ].map(([label, value], idx) => (
                  <div className="col-md-6 mb-3" key={idx}>
                    <label className="form-label fw-bold">{label}</label>
                    <input
                      type="text"
                      className="form-control"
                      value={value ?? ""}
                      disabled
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
} 